import { render } from "./app-footer-women.vue?vue&type=template&id=7de6dec0&scoped=true&ts=true"
import script from "./app-footer-women.vue?vue&type=script&lang=ts"
export * from "./app-footer-women.vue?vue&type=script&lang=ts"

import "./app-footer-women.vue?vue&type=style&index=0&id=7de6dec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de6dec0"]])

export default __exports__